import React from "react";
import {
  ArrowDownLeft, ArrowUpRight, Utensils, ShoppingBag, Home, Car, Briefcase,
  Wifi, Coffee, Gift, CircleDollarSign, Wallet,
} from "lucide-react";
import { formatMXN } from "../../lib/api";

const CATEGORY_ICONS = {
  "Salario": Briefcase, "Freelance": Briefcase, "Renta": Home, "Súper": ShoppingBag,
  "Transporte": Car, "Suscripciones": Wifi, "Restaurantes": Utensils,
  "Servicios": Wifi, "Café": Coffee, "Regalo": Gift,
};

export default function TransactionCard({ tx, testid, onClick }) {
  const isIncome = tx.type === "ingreso";
  const Icon = CATEGORY_ICONS[tx.category] || (isIncome ? ArrowDownLeft : CircleDollarSign);
  const dateLabel = (() => {
    try {
      const d = new Date(tx.date);
      return new Intl.DateTimeFormat("es-MX", { day: "2-digit", month: "short" }).format(d);
    } catch { return ""; }
  })();

  const clickable = typeof onClick === "function";
  const Container = clickable ? "button" : "div";
  const clickProps = clickable
    ? { type: "button", onClick, className: "w-full text-left flex items-center gap-4 py-4 border-b border-line/60 last:border-0 hover:bg-sage-50/30 active:bg-sage-50/60 transition-colors -mx-2 px-2 rounded-xl" }
    : { className: "flex items-center gap-4 py-4 border-b border-line/60 last:border-0" };

  return (
    <Container {...clickProps} data-testid={testid}>
      <div className={`h-11 w-11 rounded-full flex items-center justify-center shrink-0 ${
        isIncome ? "bg-sage-50 text-sage-700" : "bg-bone text-ink"
      }`}>
        <Icon size={18} strokeWidth={1.8} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-semibold text-ink truncate">
          {tx.category || (isIncome ? "Ingreso" : "Gasto")}
        </p>
        <p className="text-xs text-soft truncate">
          {tx.note || (isIncome ? "Ingreso" : "Gasto")} · {dateLabel}
        </p>
        <div className="flex items-center gap-1.5 mt-0.5 flex-wrap">
          {tx.account_name && (
            <span
              className="inline-flex items-center gap-1 text-[10px] text-soft bg-bone rounded-full px-1.5 py-0.5"
              data-testid="tx-account-chip"
            >
              <Wallet size={9} />
              {tx.account_name}
            </span>
          )}
          {tx.registered_by_name && (
            <span
              className="text-[10px] text-soft/80 italic truncate"
              data-testid="tx-registered-by"
            >
              · por {tx.registered_by_name}
            </span>
          )}
        </div>
      </div>
      <div className="text-right shrink-0">
        <p className={`font-display font-bold tabular ${isIncome ? "text-sage-700" : "text-ink"}`}>
          {isIncome ? "+" : "−"} {formatMXN(Math.abs(tx.amount))}
        </p>
        <div className="flex items-center justify-end gap-1 text-[10px] uppercase tracking-wider text-soft">
          {isIncome ? <ArrowDownLeft size={10} /> : <ArrowUpRight size={10} />}
          {isIncome ? "Ingreso" : "Gasto"}
        </div>
      </div>
    </Container>
  );
}
